import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {MessagesRequestsService} from "../../services/messages-requests.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class contactUserViewCtrl implements IController {

  user: any;

  private loading: boolean;
  private payload: any;
  private contactTypes: any;
  private selectedContactType: string;

  /* @ngInject */
  constructor(private userConstants, private IAMPermissions,
              private messagesRequestsService: MessagesRequestsService, private $filter, private $log, private commonsAlertsService: CommonsAlertsService) {
  }

  $onInit() {
    this.loading = false;
    this.payload = {};
    this.contactTypes = this.userConstants.contactTypes;

  }


  submit(form) {

    form.$setSubmitted(true);
    if (form.$valid) {
      this.loading = true;

      const recipient = this.$filter('bringozPhonePrefix')(this.user.mobilePhone);
      _.set(this.payload, 'recipient', recipient);

      this.messagesRequestsService.sendText(this.payload)
        .then(() => {
          this.commonsAlertsService.sendSMSSuccess();
          this.formSucceeded(form);
        })
        .catch((error) => {
          this.commonsAlertsService.sendSMSError();
          this.formFailed(error)
        })

    }
  }

  formSucceeded(form) {
    if (form) {
      this.loading = false;
      form.$setPristine();
      form.$setUntouched();
    }
    this.payload = {};
  }

  formFailed(error) {
    this.loading = false;
    this.$log.error('Failed to contact user, contactUserForm@submit' + error);
  }

}

angular
  .module('bringoz.admin.messages')
  .component('contactUserView', {
    bindings: {
      user: '<'
    },
    template: require('./contact-user-view.html').default,
    controller: contactUserViewCtrl
  });
